
import { ContentBlockFileData } from 'fourwaves-shared';
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { Icon } from 'fourwaves-shared/components';
import VideoPlayer from 'fourwaves-shared/src/components/media/VideoPlayer.vue';

@Component({
  components: {
    Icon,
    VideoPlayer,
  },
})
export default class ContentBlockVideo extends Vue {
  @Prop({ type: Object, required: true }) readonly video!: ContentBlockFileData;

  get videoUrl(): string {
    const fileUploadId = this.video.fileUploadId[this.$i18n.locale];
    if (!fileUploadId) return '';

    return this.$api.getFileUploadUrl(fileUploadId);
  }

  get rootClassNames(): Record<string, boolean> {
    return { '-empty': !this.videoUrl };
  }
}
